<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><a id="page_vii">We can never be gods, after all—but we can become something less than human with frightening ease.</a></p><a id="page_vii">
</a><p class="epi1"><a id="page_vii">—N. K. Jemisin</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?523112f0